import { faArrowRotateLeft } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type { PropsWithChildren } from "react";

import { T } from "@repo/transifex";
import { cn } from "~/lib/utils";

export type ClearFiltersButtonProps = PropsWithChildren<{
  onClick: () => void;
  className?: string;
}>;

// Colors (#FFE9E5 bg, #FAD4CE border, #FCDAD4 hover, #E2483C text) don't map to interface-negative-* tokens - promote if reused.
export const ClearFiltersButton = ({
  onClick,
  children,
  className
}: ClearFiltersButtonProps) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        "inline-flex h-11 items-center gap-2 whitespace-nowrap rounded-xl border border-[#FAD4CE] bg-[#FFE9E5] px-4 text-sm font-semibold text-[#E2483C] transition-colors hover:bg-[#FCDAD4]",
        className
      )}
    >
      <FontAwesomeIcon icon={faArrowRotateLeft} />
      {children ?? <T _str="Clear filters" />}
    </button>
  );
};
